import { defineModule } from '@portal/kernel';

export const manifest = defineModule({
  key: 'core-access',
  version: '0.1.0',
  kind: 'core',
  coreVersion: '^0.1.0',
  name: { vi: 'Phân quyền', en: 'Access control' },
  description: {
    vi: 'Vai trò, quyền và phạm vi dữ liệu của người dùng.',
    en: 'Roles, permissions and data scopes of users.',
  },
  dependsOn: ['core-system', 'core-audit', 'core-identity', 'core-organization'],
  database: { schema: 'core_access' },
  permissions: [
    { key: 'core-access.role.view', name: { vi: 'Xem vai trò và phân quyền', en: 'View roles' } },
    {
      key: 'core-access.role.manage',
      name: { vi: 'Quản lý vai trò và gán vai trò', en: 'Manage roles and assignments' },
    },
  ],
  navigation: [
    {
      id: 'admin.roles',
      parent: 'admin',
      label: { vi: 'Vai trò & phân quyền', en: 'Roles & permissions' },
      icon: 'shield-check',
      path: '/admin/roles',
      permission: 'core-access.role.view',
      order: 6,
    },
  ],
});
